export const RETAILER_APPROVAL_STATUS_APPROVED = 'APPROVED'
export const RETAILER_APPROVAL_STATUS_PENDING = 'PENDING'
export const RETAILER_APPROVAL_STATUS_NONE = 'NONE'

export const STOREFRONT_STATUS = {
    UNAVAILABLE: 'UNAVAILABLE',
    IN_REVIEW: 'IN_REVIEW',
    PUBLISHED: 'PUBLISHED',
    REORDER_ONLY: 'REORDER_ONLY',
    UNPUBLISHED: 'UNPUBLISHED',
}

export const THE_ALPHABET = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    '#',
]
